import { Button, FormControl, FormLabel, Input, Stack, useBoolean, useDisclosure } from '@elkaso-app/web-design';
import { BaseFilterButton } from 'components/base-table/filters';
import { usePageParams } from 'hooks/use-page-params';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

type TInputs = {
  name: string;
};

const defaultValues: TInputs = {
  name: '',
};

export const LocationNameFilterButton: React.FC = () => {
  const [isActive, setIsActive] = useBoolean(false);
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { getPageParams, setPageParams } = usePageParams();
  const params = getPageParams();

  const { register, handleSubmit, formState, reset, setValue } = useForm<TInputs>({
    defaultValues: { ...defaultValues },
  });

  // Update active filter button
  useEffect(() => {
    if (params.name) setIsActive.on();
    else setIsActive.off();
  }, [params.name, setIsActive]);

  // Update values when params change
  const updateValues = () => {
    setValue('name', (params.name as string) ?? '');
  };

  useEffect(() => {
    updateValues();
  }, [params.name]);

  const onSubmit = (data: TInputs) => {
    if (data.name?.trim()) {
      params.name = data.name.trim();
    } else {
      delete params.name;
    }
    params.page = 1; // Reset to first page when filtering
    setPageParams(params);
    onClose();
    reset(data);
  };

  const onClear = () => {
    const newParams = { ...params };
    delete newParams.name;
    newParams.page = 1;
    setPageParams(newParams);
    reset();
    onClose();
  };

  const handleClose = () => {
    onClose();
    updateValues();
  };

  const handleDisableFilterButton = () => {
    const isDisabled = Object.keys(formState.dirtyFields).length ? false : true;
    return isDisabled;
  };

  return (
    <BaseFilterButton
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={handleClose}
      isActive={isActive}
      formComponent={
        <Stack
          as='form'
          spacing='lg'
          p='md'
          pt='lg'
          onSubmit={handleSubmit(onSubmit)}
          onClick={(e) => e.stopPropagation()}>
          <FormControl>
            <FormLabel>Location Name</FormLabel>
            <Input size='sm' placeholder='Search by location name...' {...register('name')} />
          </FormControl>

          <Stack direction='row' justify='flex-end' spacing={2}>
            <Button variant='outline' colorScheme='red' onClick={onClear}>
              Clear
            </Button>
            <Button variant='outline' colorScheme='gray' onClick={handleClose}>
              Cancel
            </Button>
            <Button variant='solid' colorScheme='blue' type='submit' disabled={handleDisableFilterButton()}>
              Filter
            </Button>
          </Stack>
        </Stack>
      }
    />
  );
};
